import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { API_ENDPOINT } from 'src/app/constants/api-endpoint.constants';
import { DataService } from 'src/app/services/data.service';
import { IKarmaPointEarnMoreResponse, IUserPointWithLevelPayload, IUserTotalPointsWithLevelInfoResponse, KarmaPointsHistoryResponse } from '../models/karma-points.model.model';
import { IMedalLevelsFormFieldConfig } from '../../admin/global-gamification-triggers/gamification.model';
import { SMS_OPTIONS } from 'src/app/constants';
import { BadgesService } from '../../badges/badges.service';
import { ApiService } from 'src/app/services/api.service';
import { ClientService } from 'src/app/services/client.service';

@Injectable({
  providedIn: 'root'
})
export class KarmaPointsService {
  private apiService = inject(ApiService);
  private ds = inject(DataService);
  private badgesService = inject(BadgesService);
  private clientService = inject(ClientService);

  getUserTotalPointsWithLevelInfo(payload: IUserPointWithLevelPayload): Observable<IUserTotalPointsWithLevelInfoResponse> {
    return this.apiService.postApi<IUserTotalPointsWithLevelInfoResponse>(API_ENDPOINT.GET_USER_TOTAL_POINT_WITH_LEVEL_INFO, payload);
  }

  getHistoryPoint(payload: IUserPointWithLevelPayload): Observable<KarmaPointsHistoryResponse> {
    return this.apiService.postApi<any>(API_ENDPOINT.GET_USER_HISTORY_POINT, payload);
  }

  public getUserEarnMoreSection(payload: IUserPointWithLevelPayload): Observable<IKarmaPointEarnMoreResponse> {
    return this.apiService.postApi<any>(API_ENDPOINT.GET_USER_EARN_MORE_SECTION, payload);
  }

  public getKarmaPointsLevels(payload: any) {
    return this.apiService.postApi(API_ENDPOINT.GET_KARMA_POINTS_LEVEL, payload);
  }

  public get hasKarmaPointsAccess(): boolean {
    return this.badgesService.hasBadgesAccess() && this.clientService.client().smsSettings?.allowKarmaPoints === SMS_OPTIONS.YES;
  }

  public get hasLeaderBoardAccess(): boolean {
    return this.badgesService.hasBadgesAccess() && this.clientService.client().smsSettings?.allowLeaderBoard === SMS_OPTIONS.YES;
  }

}
